import React from 'react';

const theme = '#5e4aee';

const TwitterLogo = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72" {...props}>
      <path
        fill={theme}
        d="M55.36,19.58a15.16,15.16,0,0,1-4.89,1.91A7.56,7.56,0,0,0,44.87,19a7.79,7.79,0,0,0-7.69,7.88,8,8,0,0,0,.2,1.79,21.67,21.67,0,0,1-15.84-8.23,8,8,0,0,0-1,4A7.93,7.93,0,0,0,23.92,31a7.51,7.51,0,0,1-3.48-1v.1a7.83,7.83,0,0,0,6.17,7.72,7.21,7.21,0,0,1-2,.28,7.75,7.75,0,0,1-1.45-.14,7.72,7.72,0,0,0,7.18,5.47,15.19,15.19,0,0,1-9.54,3.37,13.84,13.84,0,0,1-1.83-.11,21.32,21.32,0,0,0,11.77,3.54c14.14,0,21.87-12,21.87-22.42,0-.34,0-.68,0-1a15.8,15.8,0,0,0,3.83-4.07A15.29,15.29,0,0,1,52,23.94,8,8,0,0,0,55.36,19.58Z"
      />
    </svg>
  );
};

export default TwitterLogo;
